module.exports = __webpack_public_path__ + "media/landing_page/hero-mobile-4-b03fca08.webp";